import React, { useEffect, useRef, useState } from 'react';
import { TextEditor } from 'Core/components/editor';
import { useDispatch, useSelector } from 'react-redux';
import { showToast } from '../../core/redux/toast/slice';
import { useDocumentUpload } from '../../core/hooks';
import { addQualityAlert, deleteQualityAlert } from './store/slice';

const initData = {
  processId: '',
  description: '',
  dateTime: new Date().toISOString(),
  userId: localStorage.getItem('UserId'),
  status: 'Active',
  isDeleted: 0,
  title: '',
  files: [],
};

const QualityAlertAddEditForm = ({
  data,
  onChanges,
  partId,
  isEditMode,
  invalidFields = [],
  showValidation = false,
  formRef,
  setInvalidFields = () => {},
}) => {
  const dispatch = useDispatch();
  const { uploadDocuments } = useDocumentUpload();
  const [okTempFile, setOkTempFile] = useState(null);
  const [notOkTempFile, setNotOkTempFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const okFileInputRef = useRef(null);
  const notOkFileInputRef = useRef(null);
  const [fileRows, setFileRows] = useState(data ? data : [{ ...initData, partId: partId }]);
  const [formData, setFormData] = useState(data ? fileRows[0] : { ...initData, partId: partId });
  const formReference = useRef(null);
  const isTitleReadOnly = Array.isArray(data) && data.length > 0;

  useEffect(() => {
    if (formRef) {
      formRef(formReference);
    }
  }, [formRef]);

  // useEffect(() => {
  //   if (data) {
  //     setFormData(data);
  //     //setQualityFiles(data?.files || []);

  //     // setQualityFiles(data?.files?.filter(f => f?.file) || []);
  //   }
  // }, [data]);

  //   const updateFormField = (fieldName, value) => {
  //     setFormData(prevData => ({
  //       ...prevData,
  //       [fieldName]: value,
  //     }));
  //     onChanges({ ...formData, [fieldName]: value });
  //   };

  //   const updateFilesField = value => {
  //     setQualityFiles(value);
  //     updateFormField('files', value);
  //   };

  // Fix 2: Update both formData and call onChanges with the latest data
  const updateFormField = (fieldName, value) => {
    const updatedFormData = {
      ...formData,
      [fieldName]: value,
      files: fileRows,
    };
    setFormData(updatedFormData);

    // Remove from invalidFields if user starts typing valid input
    if (value && (!Array.isArray(value) ? value.toString().trim() !== '' : value.length > 0)) {
      setInvalidFields(prev => prev.filter(field => field !== fieldName));
    }

    // Call onChanges with the updated data
    if (onChanges) {
      onChanges(updatedFormData);
    }
  };

  const uploadFile = async file => {
    const form = new FormData();
    form.append('file', file);
    form.append('uploadCategory', 'QUALITYALERT');
    const result = await uploadDocuments(form);
    return result;
  };

  const handleAddFiles = async () => {
    if (!okTempFile && !notOkTempFile && !formData.description.trim()) return;
    setUploading(true);
    try {
      const row = {
        title: formData.title,
        status: 'Active',
        isDeleted: false,
        dateTime: new Date().toISOString(),
        userId: localStorage.getItem('UserId'),
        processId: '',
        partId: partId,
        description: formData.description.replace(/<\/?[^>]+(>|$)/g, '').trim(),
        files: [],
      };
      if (okTempFile && notOkTempFile) {
        const okPath = await uploadFile(okTempFile);
        if (okPath == null) throw '';

        const notOkPath = await uploadFile(notOkTempFile);
        if (notOkPath == null) throw '';

        row.files = [
          {
            file: okPath?.relativePath,
            extension: '',
            isDeleted: false,
            isOk: true,
          },
        ];
        okFileInputRef.current.value = '';
        setOkTempFile(null);

        row.files = [
          ...row.files,
          {
            file: notOkPath?.relativePath,
            extension: '',
            isDeleted: false,
            isOk: false,
          },
        ];
        notOkFileInputRef.current.value = '';
        setNotOkTempFile(null);

        dispatch(addQualityAlert(row));

        setFileRows(prev => [...prev, row]);
        updateFormField('description', '');
      } else {
        dispatch(showToast({ message: 'Ok and NotOk Images are required!', type: 'information' }));
      }
    } catch {
      dispatch(showToast({ message: 'Error uploading files', type: 'danger' }));
    } finally {
      setUploading(false);
    }
  };

  const handleDeleteFile = async (alertIndex, alertRow) => {
    if (!alertRow?.id) {
      // If the alert is not saved yet (no ID), just remove from UI
      setFileRows(prev => prev.filter((_, i) => i !== alertIndex));
      return;
    }

    try {
      await dispatch(deleteQualityAlert(alertRow.id)).unwrap();
      setFileRows(prev => prev.filter((_, i) => i !== alertIndex));
    } catch (error) {
      dispatch(showToast({ message: 'Failed to delete Quality Alert', type: 'danger' }));
    }
  };

  const getDocumentName = path => {
    const rawFileName = path?.split('/')?.pop(); // Get filename from URL
    const decoded = decodeURIComponent(rawFileName); // Decode %28 -> ( etc.
    const cleanName = decoded.replace(/_[a-f0-9\-]{36}/i, ''); // Remove UUID
    return cleanName;
  };

  return (
    <form ref={formReference} className="needs-validation" noValidate>
      <div className="form-row">
        <div className="m-2">
          <div className="row m-2">
            <div className="col-lg-5 col-md-3 col-sm-12">
              <div className="input-blocks ">
                <label>Title</label>
                <input
                  placeholder=""
                  type="text"
                  value={formData?.title}
                  disabled={isTitleReadOnly}
                  className={`form-control${showValidation && invalidFields.includes('title') ? ' is-invalid' : ''}`}
                  onChange={e => updateFormField('title', e.target.value)}
                />
                {/* {showValidation && invalidFields.includes('title') && (
                  <div className="invalid-feedback">Please enter a Title</div>
                )} */}
              </div>
            </div>
          </div>

          <div className="row m-2">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="input-blocks">
                <label>
                  Instruction <span className="text-danger"></span>
                </label>
                <div className="input-blocks">
                  <TextEditor
                    onChange={val => updateFormField('description', val)}
                    readOnly={isEditMode}
                  />
                  {showValidation && invalidFields.includes('description') && (
                    <div className="text-danger mt-1">Please enter a Description</div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Picture Uploads*/}
          <h5 className="header-five">Picture Uploads</h5>
          {showValidation && invalidFields.includes('files') && (
            <div className="text-danger ms-3 mb-2">Please upload at least one file</div>
          )}
          <div className="p-3">
            <div className="row">
              <div className="col-md-6">
                <label>
                  <strong>OK Image</strong>
                </label>
                <input
                  type="file"
                  className="form-control mb-2"
                  ref={okFileInputRef}
                  onChange={e => setOkTempFile(e.target.files[0])}
                />
              </div>
              <div className="col-md-6">
                <label>
                  <strong>Not OK Image</strong>
                </label>
                <input
                  type="file"
                  className="form-control mb-2"
                  ref={notOkFileInputRef}
                  onChange={e => setNotOkTempFile(e.target.files[0])}
                />
              </div>
              <div className="col-md-12">
                <button
                  type="button"
                  className="btn btn-info float-end my-2"
                  onClick={handleAddFiles}
                  disabled={uploading || (!okTempFile && !notOkTempFile)}
                >
                  {uploading ? 'Uploading...' : 'Add'}
                </button>
              </div>
            </div>
            {fileRows.length > 0 && (
              <div className="row m-1">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Instruction</th>
                        <th>OK Picture</th>
                        <th>Not OK Picture</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {fileRows.map((row, index) => {
                        const okFile = row.files.find(file => file.isOk === true);
                        const notOkFile = row.files.find(file => file.isOk === false);
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{row.description}</td>
                            <td>
                              {okFile ? (
                                <>
                                  <div>{getDocumentName(okFile.file)}</div>
                                  <a
                                    href={okFile.file}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-sm btn-outline-success mt-1"
                                  >
                                    View
                                  </a>
                                </>
                              ) : (
                                '-'
                              )}
                            </td>
                            <td>
                              {notOkFile ? (
                                <>
                                  <div>{getDocumentName(notOkFile.file)}</div>
                                  <a
                                    href={notOkFile.file}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-sm btn-outline-danger mt-1"
                                  >
                                    View
                                  </a>
                                </>
                              ) : (
                                '_'
                              )}
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-danger"
                                // onClick={() =>
                                //   setFileRows(prev => prev.filter((_, i) => i !== index))
                                // }
                                onClick={() => handleDeleteFile(index, row)}
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </form>
  );
};

export default QualityAlertAddEditForm;
